import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';
import { useTrackView } from 'src/app/shared/hooks/tracking';

type Result = ModelHookResult<
	{
		displayName: string;
		id: string;
	},
	{
		trackSapClick: () => void;
	}
>;

export function useSapToDm(): Result {
	const {
		data: { displayName, id },
	} = useDecisionMakerProfilePageData();
	const track = useTracking();

	const trackSapClick = useCallback(() => {
		void track('dm_profile_sap_click', { source_location: 'sap_container' });
	}, [track]);

	useTrackView('dm_profile_sap_view');

	return {
		data: {
			displayName,
			id,
		},
		actions: {
			trackSapClick,
		},
	};
}
